import { Component, OnDestroy, OnInit } from '@angular/core';
import { Platform } from '@ionic/angular';
import { Router } from '@angular/router';
// import { BarcodeScanner } from '@capacitor-community/barcode-scanner';
import { ErrorService } from 'src/app/services/general/error.service';
import { BarcodeScannerService } from 'src/app/services/general/barcode-scanner.service';
/**
 * Check-in scan page
 */
@Component({
  selector: 'app-checkin-scan',
  templateUrl: './checkin-scan.page.html',
  styleUrls: ['./checkin-scan.page.scss'],
})
export class CheckinScanPage implements OnInit, OnDestroy {

  /**
   * Reset flag
   */
  reset: boolean;

  /**
   * Constructor
   * @param router router
   * @param platform platform
   */
  constructor(
    private router: Router,
    private platform: Platform,
    private barcodeScannerService: BarcodeScannerService,
    private errorService: ErrorService,
  ) { }

  ngOnInit(): void {
    this.reset = true;
  }

  ngOnDestroy(): void {
    this.reset = false;
    this.stopScan();
  }

  /**
   * Before view enter
   */
  ionViewWillEnter() {
    this.reset = true;
  }

  /**
   * Before view leave
   */
  ionViewWillLeave() {
    this.reset = false;
    this.stopScan();
  }

  /**
   * Go back
   */
  goBack() {
    this.router.navigate(['/tabs-checkin/list']);
  }

  /**
   * Stop scanning
   */
  async stopScan() {
    if (this.platform.is('hybrid')) {
      try {
        await this.barcodeScannerService.stopScan();
        // BarcodeScanner?.stopScan();
        // BarcodeScanner?.showBackground();
      } catch (err) {
        this.errorService.logError(err);
      }
    }
  }

}
